<template>
  <b-row class="mt-3" v-if="cities.length">
    <span>&MediumSpace;شهرهایی که ارسال به آنها رایگان است:</span>
    &MediumSpace;<span class="text-success" v-for="city in cities">
      &MediumSpace;{{ city.value.province.name }}:{{ city.value.name }}&MediumSpace;
    </span>
  </b-row>

</template>

<script>
export default {
  name: "FreeCities",
  props: ['cities'],
}
</script>

<style scoped>

</style>